import { useIntl } from 'react-intl'

import CommonButton from 'components/Button/CommonButton'
import { subscriptionManagementMessages } from '../../features/home/components/HomeSubscription/SubscriptionManagement/messages'
import { commonMessages } from 'app/i18n/messages'
import {
  SubsManageBottomPanelContainer,
  StyledTotalToPay,
  SubsManageBottomPanelButtonsWrapper,
  SubsManageBottomPanelWrapper,
} from './styles'

interface SubsManageBottomPanelProps {
  isDowngrade?: boolean
  isSubmitDisabled?: boolean
  totalToPayAmount: string
  submitLabel: string
  handleSubmit: () => void
  handleCancel: () => void
}

function SubsManageBottomPanel({
  isDowngrade = false,
  isSubmitDisabled = false,
  totalToPayAmount,
  handleSubmit,
  handleCancel,
  submitLabel,
}: SubsManageBottomPanelProps) {
  const { formatMessage } = useIntl()
  return (
    <SubsManageBottomPanelContainer>
      <SubsManageBottomPanelWrapper>
        {false && !isDowngrade && (
          <StyledTotalToPay>
            <div>
              {formatMessage(subscriptionManagementMessages.totalToPay)}
              :&nbsp;
            </div>
            <div>{totalToPayAmount}</div>
          </StyledTotalToPay>
        )}
        <SubsManageBottomPanelButtonsWrapper>
          <CommonButton variant="secondary" onClick={handleCancel}>
            {formatMessage(commonMessages.cancel)}
          </CommonButton>
          <CommonButton
            variant="primary"
            type="submit"
            disabled={isSubmitDisabled}
            onClick={handleSubmit}
          >
            {submitLabel}
          </CommonButton>
        </SubsManageBottomPanelButtonsWrapper>
      </SubsManageBottomPanelWrapper>
    </SubsManageBottomPanelContainer>
  )
}

export default SubsManageBottomPanel
